<script>
  import axios from "axios";
  import { link } from "svelte-spa-router";
  import Layout from "../../Layout/Layout.svelte";
  import MenuHeading from "../../shared/MenuHeading.svelte";
  import Select from "svelte-select";
  import { Circle } from "svelte-loading-spinners";
  import * as ls from "local-storage";
  import config from "../../stores/config";

  let uploading = false;

  let customer = null;

  const handleClear = () => {
    customer = null;
  };

  const handleSubmit = async (e) => {
    if (!customer.value) alert("Please choose a customer!");
    else {
      uploading = true;

      let data = {
        customerID: customer.value,
        ref: customer.label,
      };

      axios
        .post(`${$config.backendURL}/orders`, data, {
          headers: { authorization: ls.get("jwt") },
        })
        .then((res) => {
          console.log(res.data);
          uploading = false;
          alert(`☑ Added Successfully`);
          // GO TO ORDER DETAILS
          window.location = `/#/orders/${res.data._id}`;
          handleClear();
        })
        .catch((err) => {
          alert("There was a problem, Refresh the page and retry");
          console.log(err);
          uploading = false;
        });
    }
  };
</script>

<svelte:head>
  <title>Add Customer to Order | Fabi CC System</title>
</svelte:head>

<Layout>
  <MenuHeading
    title="Add Customer to Order"
    description="Enter the customer who ordered. Make sure he already exists before proceeding or create one if he doesn't exist in the customer tab..."
  />

  <div class="flex justify-end mb-6">
    <a class="btn btn-green-outline" use:link href="/orders">
      <i class="fas fa-arrow-left mr-3" />
      Return to Orders
    </a>
  </div>

  <form
    on:submit|preventDefault={handleSubmit}
    class="grid grid-cols-1 gap-y-4 text-gray-500 pb-8"
  >
    <div class="grid grid-cols-1 gap-8">
      <div class="grid grid-cols-5 gap-2 items-center">
        <div>Choose existing customer :</div>
        <div class="col-span-4">
          <Select
            items={$config.customers}
            on:select={(e) => (customer = e.detail)}
          />
        </div>
      </div>
    </div>

    {#if uploading}
      <div class="grid grid-cols-1 gap-8">
        <div class="flex items-center justify-center btn btn-green-outline">
          <Circle size="25" color="rgb(16, 185, 129)" unit="px" />
          <span class="ml-4">Please wait...</span>
        </div>
      </div>
    {:else}
      <!-- else content here -->
      <div class="grid grid-cols-2 gap-8">
        <button class="btn btn-green-outline" on:click={handleClear}>
          <i class="fas fa-times-circle mr-3" />
          Clear Form
        </button>
        <button class="btn btn-green">
          <i class="fas fa-check-circle mr-3" />
          Save to Database
        </button>
      </div>
    {/if}
  </form>
</Layout>
